import { defineComponent as w, inject as i, computed as t, createElementBlock as G, openBlock as d, mergeProps as x, unref as o, createElementVNode as B, createBlock as S, renderSlot as n, normalizeClass as C, createVNode as k, withCtx as T, Teleport as W } from "vue";
import { classesFromBreakpointProps as p } from "../../breakpoints.js";
import { toCamelCase as L } from "../../util.js";
import e from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Toolbar/toolbar.js";
import X from "../../_virtual/t_global_breakpoint_lg.js";
import h from "../Button.vue2.js";
import { useWindowSize as E } from "@vueuse/core";
import { ToolbarExpandedKey as I, ToolbarToggleExpandedKey as M } from "./Toolbar.vue2.js";
import { ToolbarContentExpandableRefKey as P } from "./ToolbarContent.vue2.js";
import { useOUIAProps as $ } from "../../helpers/ouia.js";
const q = /* @__PURE__ */ w({
  name: "PfToolbarToggleGroup",
  __name: "ToolbarToggleGroup",
  props: {
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    variant: {},
    alignItems: {},
    alignSelf: {},
    overflowContainer: { type: Boolean },
    visibility: {},
    visibilitySm: {},
    visibilityMd: {},
    visibilityLg: {},
    visibilityXl: {},
    visibility2xl: {},
    align: {},
    alignSm: {},
    alignMd: {},
    alignLg: {},
    alignXl: {},
    align2xl: {},
    gap: {},
    gapSm: {},
    gapMd: {},
    gapLg: {},
    gapXl: {},
    gap2xl: {},
    columnGap: {},
    columnGapSm: {},
    columnGapMd: {},
    columnGapLg: {},
    columnGapXl: {},
    columnGap2xl: {},
    rowGap: {},
    rowGapSm: {},
    rowGapMd: {},
    rowGapLg: {},
    rowGapXl: {},
    rowGap2xl: {},
    rowWrap: {},
    rowWrapSm: {},
    rowWrapMd: {},
    rowWrapLg: {},
    rowWrapXl: {},
    rowWrapXl2: {},
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean },
    xl2: { type: Boolean }
  },
  setup(u) {
    const a = u, g = $({ id: a.ouiaId, safe: a.ouiaSafe }), { width: c } = E(), r = i(I), f = i(M), s = i(P), v = t(() => [
      ...p(a, ["visibility"], e, { short: !0 }),
      ...p(a, ["spacer", "spaceItems", "align"], e),
      ...p(a, [""], e)
    ]), y = t(() => a.variant ? e.modifiers[L(a.variant)] : null), b = t(() => {
      const l = parseInt(X.value);
      return c.value < l;
    });
    return (l, m) => (d(), G("div", x(o(g), {
      class: [y.value, o(e).toolbarGroup, o(e).modifiers.toggleGroup, v.value]
    }), [
      B("div", {
        class: C(o(e).toolbarToggle)
      }, [
        k(h, {
          variant: "plain",
          "aria-label": "Show Filters",
          "aria-expanded": o(r),
          "aria-haspopup": o(r) && b.value,
          onClick: m[0] || (m[0] = (_) => o(f) ?? void 0)
        }, {
          default: T(() => [
            n(l.$slots, "icon")
          ]),
          _: 3
        }, 8, ["aria-expanded", "aria-haspopup"])
      ], 2),
      o(r) && o(s) ? (d(), S(W, {
        key: 0,
        to: o(s)
      }, [
        n(l.$slots, "default")
      ], 8, ["to"])) : n(l.$slots, "default", { key: 1 })
    ], 16));
  }
});
export {
  q as default
};
